import {ChangeDetectorRef, Component, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {DictionaryObject} from '../../../../../common/api';
import {SharingRulesGroup} from '../api/entity/sharing-rules-group.model';
import {isNullOrUndefined} from 'util';
import {RevenueDistributionExceptionComponent} from './revenue-distribution.exception.component';
import {ControlContainer, NgForm, NgModelGroup} from '@angular/forms';

@Component({
    selector: 'tfl-revenue-distribution-exceptions',
    template: `
        <div ngModelGroup="exceptionsGroup" #fg="ngModelGroup">
            <div class="row col-xs-12" *ngFor="let e of exceptions;let i = index">
                <tfl-revenue-distribution-exception
                    [profile-id]="profileId"
                    [index]="i"
                    [model]="e"
                    [collapsed]="exceptions.length >= 5"
                    [available-profile-kinds]="availableProfileKinds"
                    [available-profiles]="availableProfiles"
                    [availableFeeServices]="availableFeeServices"
                    (removed)="onExceptionRemoved($event)"
                    (conditionsChanged)="onConditionChanges()"
                >
                </tfl-revenue-distribution-exception>
            </div>
        </div>
    `,
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})

export class RevenueDistributionExceptionsComponent {

    @Input('profile-id') profileId;
    @Input() exceptions: SharingRulesGroup[];
    @Input() availableFeeServices: DictionaryObject[];
    @Input('availableProfileKinds') availableProfileKinds: DictionaryObject[];
    @Input('availableProfiles') availableProfiles: DictionaryObject[];
    @Output('customChange') customChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChildren(RevenueDistributionExceptionComponent) exceptionComponents: QueryList<RevenueDistributionExceptionComponent>;
    @ViewChild('fg') formGroup: NgModelGroup;

    constructor(private _cdr: ChangeDetectorRef) {}

    onExceptionRemoved(index: number) {
        if (!isNullOrUndefined(this.exceptions[index])) {
            this.exceptions.splice(index, 1);
            if (this.formGroup.control) {
                this.formGroup.control.markAsDirty();
            }
        }
        this._cdr.detectChanges();
    }

    onConditionChanges() {
        this._cdr.detectChanges();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/exceptions/revenue-distribution-exceptions.component.ts